import QRCode from "qrcode";

export function initTwoFactorQrCode() {
  document.querySelectorAll("[data-two-factor-qr-code]").forEach((canvas) => {
    const provisioningUri = canvas.dataset.provisioningUri;
    if (!provisioningUri || canvas.dataset.rendered === "true") return;

    QRCode.toCanvas(
      canvas,
      provisioningUri,
      {
        width: 220,
        margin: 2,
        errorCorrectionLevel: "M",
        color: {
          dark: "#111827",
          light: "#ffffff"
        }
      },
      (error) => {
        if (error) {
          const fallback = canvas.closest("[data-two-factor-qr-wrapper]")?.querySelector("[data-two-factor-qr-fallback]");
          if (fallback) fallback.classList.remove("d-none");
          return;
        }

        canvas.dataset.rendered = "true";
      }
    );
  });
}
